import React, { useState } from "react";
import "./Ticket.scss";
import { BsChevronDown } from "react-icons/bs";
import { FiCalendar } from "react-icons/fi";
import { BiCheckCircle } from "react-icons/bi";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { locale } from "../../translate/sweden";

const Ticket = (props) => {
  const [open, setOpen] = useState(false);
  const widgetInfo = useSelector((state) => state.widget.widget);

  return (
    <div className={"Ticket" + (open ? " active" : "")}>
      <div className="ticketHeader" onClick={() => setOpen((p) => !p)}>
        <p
          style={{
            color: widgetInfo.company.widget_settings.main_color
              ? widgetInfo.company.widget_settings.main_color
              : "#1A73E8",
          }}
        >
          {open
            ? locale.lastBookingStep.closeTicket
            : locale.lastBookingStep.openTicket}
        </p>
        <BsChevronDown
          style={{
            color: widgetInfo.company.widget_settings.main_color
              ? widgetInfo.company.widget_settings.main_color
              : "#1A73E8",
          }}
        />
      </div>
      <div className="ticketContent">
        <div className="flex">
          <FiCalendar />
          <p>
            {dayjs(props.time.date).format("DD MMM YYYY")} at{" "}
            {props.time.time.substring(0, 5)}
          </p>
        </div>
        <div className="flex">
          <BiCheckCircle />
          <p>
            {props.service.service.length > 17
              ? `${props.service.service.substring(0, 17)}...`
              : props.service.service}{" "}
            {props.staff &&
              `${locale.with} ${props.staff.first_name} ${props.staff.last_name}`}
          </p>
        </div>
        <div className="serviceInfo">
          {props.service.duration} minuter, {props.service.price}
          {locale.currency}
        </div>
        <div className="total">
          <h1 style={{ textTransform: "uppercase" }}>
            {locale.lastBookingStep.total}
          </h1>
          <h1>
            {props.service.price}
            {locale.currency}
          </h1>
        </div>
        <div className="paymentMethod">
          {locale.lastBookingStep.paymentMethod}
        </div>
      </div>
    </div>
  );
};

export default Ticket;
